import React from 'react';
import { Box, Typography } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const TrendingIndicator = ({ trend, value }) => {
  return (
    <Box display="flex" alignItems="center">
      {trend === 'up' ? (
        <TrendingUp sx={{ color: '#0FA459' }} />
      ) : trend === 'down' ? (
        <TrendingDown sx={{ color: '#D31333' }} />
      ) : null}
      <Typography
        variant="body1"
        component="span"
        fontSize={16}
        marginLeft={'4px'}
        color={trend === 'up' ? '#0FA459' : '#D31333'}
      >
        {`${value} %`}
      </Typography>
    </Box>
  );
};

export default TrendingIndicator;
